<template>
    <div class="table_container">
      <div class="table-btn" style="margin: 24px 0 12px 0">
        <el-button
          v-if="$route.query.operateType !== '查看'"
          :disabled="tableData.length >= 15"
          type="primary"
          size="small"
          @click="handleAdd()"
          >添加</el-button
        >
      </div>
      <el-table
        ref="tableRef"
        highlight-current-row
        :border="true"
        :data="tableData"
        :header-cell-style="{
          background: '#EFEFEF',
          color: '#000',
          borderColor: '#dcdfe6'
        }"
        :cell-class-name="cellClassName"
        @cell-click="handleCellClick"
      >
        <el-table-column label="序号" width="50px" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="moneyType"
          label="费用类别"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-select
              v-if="
                editField === 'moneyType' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.moneyType"
              placeholder="请选择"
              filterable
              clearable
              size="mini"
              automatic-dropdown
              @visible-change="visibleChange"
              @change="confirmEdit"
            >
              <el-option label="差旅费" value="差旅费"></el-option>
              <el-option label="商务政策费用" value="商务政策费用"></el-option>
              <el-option label="其他费用" value="其他费用"></el-option>
            </el-select>
            <div v-else>
              {{ scope.row.moneyType }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="thingsDescription"
          label="事项描述"
          min-width="110px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField === 'thingsDescription' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.thingsDescription"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.thingsDescription }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="amount"
          label="金额(元)"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField === 'amount' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.amount"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.amount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="budget"
          label="是否有预算"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-select
              v-if="
                editField === 'budget' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.budget"
              placeholder="请选择"
              filterable
              clearable
              size="mini"
              automatic-dropdown
              @visible-change="visibleChange"
              @change="confirmEdit"
            >
              <el-option label="是" value="是"></el-option>
              <el-option label="否" value="否"></el-option>
              
            </el-select>
            <div v-else>
              {{ scope.row.budget }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="estimatedSpendingMonths"
          label="预计支出月份"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
           
              <el-date-picker
              v-if="
                  editField === 'estimatedSpendingMonths' && editIndex === scope.$index
                "
                format="yyyy 年 MM 月"
                value-format="yyyy-MM"
                id="focusRef"
                v-model="scope.row.estimatedSpendingMonths"
                size="mini"
                style="width: 100%"
                @blur="confirmEdit"
                @change="confirmEdit"
                type="month"
                placeholder="选择月">
              </el-date-picker>
            <div v-else>
              {{ scope.row.estimatedSpendingMonths }}
            </div>
          </template>
        </el-table-column>
        <!-- 备注 -->
        <el-table-column
          prop="remark"
          label="备注"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField === 'remark' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.remark"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.remark }}
            </div>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column
          v-if="$route.query.operateType !== '查看'"
          label="操作"
          align="center"
          width="90px"
          fixed="right"
        >
          <template slot-scope="scope">
            <!-- 删除 -->
            <el-button size="mini" type="text" @click="handleDelete(scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
</template>
  
  <script>
  import UploadImg from "@/components/uploadImgTable.vue";
  import { addOrUpdateMoneyApi } from "@/api/saleTaskCollection";
  
  export default {
    components: { UploadImg },
    data() {
      return {
        tableData: [],
        editField: "", // 编辑单元格
        editIndex: -1 // 编辑行索引
      };
    },
    methods: {
      init(data) {
        this.tableData = [];
        if (data) {
          data.map(item => {
            this.tableData.push({
              ...item,
              img: item.img ? item.img.split(",") : []
            });
          });
        }
      },
      // 添加
      handleAdd() {
        this.tableData.push({
          remark: "",
          estimatedSpendingMonths: "",
          budget: "",
          amount: "",
          thingsDescription: "",
          moneyType:""
          
        });
      },
      // 删除
      handleDelete(index) {
        this.tableData.splice(index, 1);
      },

      // 获取单元格索引
      cellClassName({ row, column, rowIndex, columnIndex }) {
        row.index = rowIndex;
        column = { ...column, index: columnIndex };
      },
      // 点击单元格
      handleCellClick(row, column) {
        this.handleColumn(column.property, row.index ?? -1);
        this.tableData[row.index][column.property] =
          this.tableData[row.index][column.property] ?? undefined;
      },
      // 点击单元格编辑
      handleColumn(field, index) {
        if (this.$route.query.operateType === "查看") return;
        this.editField = field;
        this.editIndex = index ?? -1;
        this.$nextTick(() => {
          document.querySelector("#focusRef")?.focus();
          document.querySelector("#focusRef .el-input__inner")?.focus();
        });
      },
      // 确认编辑
      confirmEdit() {
        this.editField = "";
        this.editIndex = -1;
      },
      // el-select 显示隐藏选项框时触发
      visibleChange(visible) {
        if (!visible) {
          this.confirmEdit();
        }
      },
      // 保存
      async handleSave(params) {
        try {
          const submitData = {
            ...params,
            dataList: this.tableData
          };
          
          const res = await addOrUpdateMoneyApi(submitData);
          if (res.status == 0) {
            this.$DonMessage.success("操作成功！");
            this.tableData = res.data;
            
          } else {
            this.$DonMessage.error(res.message);
          }
        } catch (error) {
          console.error(error);
        }
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .table_container {
    padding: 15px 18px 0 50px;
    .number_input {
      width: 100%;
      padding: 0;
      ::v-deep .el-input__inner {
        padding: 0 8px;
      }
    }
  }
  </style>
  